import { object, string } from 'yup';

export const SchemaLogin = object({
	username: string().required('E-mail ou username é obrigatório.'),
	password: string().required('Senha é obrigatório.'),
});
